import Swal from "sweetalert2";

/**
 * Handler desde request HTTP
 * @param response 
 */
export function errorMessageHandler(response:any){

   let mensajeError = '';

   try {

       if(response.originalError.error.message){
          mensajeError = response.originalError.error.message;
       }else{

         if(response.message)
            mensajeError = response.message;

       }
   } catch (error) {}

   if(!mensajeError)
       mensajeError = 'Error Desconocido';

    Swal.fire({
    title: 'Atención',
    html: mensajeError,
    icon: 'warning',
    confirmButtonText: 'Aceptar'
    });
   
   
}

/**
 * Handler controlado 
 * @param response 
 */
export function errorMessage(mensajeError:string){
 
   if(!mensajeError)
       mensajeError = 'Error Desconocido';

    Swal.fire({
    title: 'Atención',
    html: mensajeError,
    icon: 'warning',
    confirmButtonText: 'Aceptar'
    });
   
   
}